import { useState } from 'react';
import Swal from 'sweetalert2';

export function useEquipmentImage(isEditMode) {
    const [equipmentImage, setEquipmentImage] = useState(null);
    const [imageToDeleteOnSave, setImageToDeleteOnSave] = useState(null);

    // Called when user picks a new file — caller is responsible for updating imagePreview
    const selectNewImage = (file, currentDbUrl) => {
        if (isEditMode && currentDbUrl) setImageToDeleteOnSave(currentDbUrl);
        setEquipmentImage(file);
    };

    // Shows a Swal confirm in edit mode, returns true if the caller should clear the image
    const clearImage = async (currentDbUrl) => {
        if (isEditMode) {
            const result = await Swal.fire({
                title: 'Êtes-vous sûr ?',
                text: "La photo sera définitivement supprimée à l'enregistrement de l'équipement.",
                icon: 'warning', showCancelButton: true,
                confirmButtonText: 'Oui, supprimer', cancelButtonText: 'Non, annuler',
                customClass: 'swal-custom'
            });
            if (!result.isConfirmed) return false;
            if (currentDbUrl) setImageToDeleteOnSave(currentDbUrl);
        }
        setEquipmentImage(null);
        return true;
    };

    // Upload the selected image to Cloudinary, returns the URL or null
    const uploadImage = async () => {
        if (!equipmentImage) return null;
        const formData = new FormData();
        // equipmentImage is a compressed Blob (not a File), so it has no
        // .name — an explicit filename is required for FormData/Cloudinary.
        formData.append('image', equipmentImage, 'equipment-photo.jpg');
        try {
            const r = await fetch(`${process.env.REACT_APP_API_URL}/upload_image`, { method: 'POST', body: formData });
            if (r.ok) { const data = await r.json(); return data.image_url; }
            Swal.fire({ title: 'Erreur', text: "Échec du téléchargement de l'image.", icon: 'error', confirmButtonText: 'OK', customClass: 'swal-custom' });
            return null;
        } catch (err) {
            console.error("Erreur lors du téléchargement de l'image:", err);
            return null;
        }
    };

    // Delete the old image from Cloudinary (called just before save in edit mode)
    const deleteOldImage = async () => {
        if (!imageToDeleteOnSave) return;
        try {
            await fetch(`${process.env.REACT_APP_API_URL}/delete_image`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ image_url: imageToDeleteOnSave })
            });
        } catch (err) {
            console.error('Erreur API:', err);
        }
    };

    return { imageToDeleteOnSave, pendingImage: equipmentImage, selectNewImage, clearImage, uploadImage, deleteOldImage };
}
